module.exports = __webpack_public_path__ + "media/tip.0399c0d0.mp3";